import { createAction, props } from '@ngrx/store';
import { ISpeech } from 'src/interfaces/speech.interface';

export const addAuthor = createAction(
  '[SPEECH] Add Author',
  props<{ author: string }>()
);

export const addSpeech = createAction(
  '[SPEECH] Add Speech',
  props<{ data: ISpeech }>()
);

export const setActiveSpeech = createAction(
  '[SPEECH] Set Active Speech',
  props<{ obj: ISpeech }>()
);

export const removeSpeech = createAction('[SPEECH] Remove Speech');
export const editingSpeech = createAction('[SPEECH] Editing Speech');

export const editSpeech = createAction(
  '[SPEECH] Edit Speech',
  props<{ data: ISpeech }>()
);
